import { Controller } from "@hotwired/stimulus";
import Cropper from "cropperjs";

// Connects to data-controller="cropper"
export default class extends Controller {
  static targets = ["x", "y", "width", "height"];
  static values = {
    initial: Object,
  };

  connect() {
    const image = this.element.querySelector("img");
    const controller = this;
    const cropper = new Cropper(image, {
      minContainerWidth: 298,
      minContainerHeight: 173,
      viewMode: 1,
      zoomOnWheel: false,
      ready() {
        if (controller.initialValue) {
          this.cropper.setData({
            x: parseInt(controller.initialValue.x),
            y: parseInt(controller.initialValue.y),
            width: parseInt(controller.initialValue.width),
            height: parseInt(controller.initialValue.height),
          });
        }
      },
      crop(event) {
        controller.xTarget.value = Math.round(event.detail.x);
        controller.yTarget.value = Math.round(event.detail.y);
        controller.widthTarget.value = Math.round(event.detail.width);
        controller.heightTarget.value = Math.round(event.detail.height);
      },
    });
  }
}
